import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NoticiasPage from './pages/NoticiasPage';
import NoticiaDetalhe from './pages/NoticiaDetalhe';
import TagPage from './pages/TagPage';
import SobrePage from './pages/SobrePage';
import CursosPage from './pages/CursosPage';
import PodcastPage from './pages/PodcastPage';
import AtualizacoesLegislativasPage from './pages/AtualizacoesLegislativasPage';
import EntrevistasPage from './pages/EntrevistasPage';
import BatePapoPage from './pages/BatePapoPage';
import ContatoPage from './pages/ContatoPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import { AdminAuthProvider } from './context/AdminAuthContext';

function App() {
  return (
    <AdminAuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<NoticiasPage />} />
            <Route path="/noticias" element={<NoticiasPage />} />
            <Route path="/noticias/:slug" element={<NoticiaDetalhe />} />
            <Route path="/tags/:tag" element={<TagPage />} />
            <Route path="/sobre" element={<SobrePage />} />
            <Route path="/cursos" element={<CursosPage />} />
            <Route path="/podcast" element={<PodcastPage />} />
            <Route path="/atualizacoes-legislativas" element={<AtualizacoesLegislativasPage />} />
            <Route path="/entrevistas" element={<EntrevistasPage />} />
            <Route path="/bate-papo" element={<BatePapoPage />} />
            <Route path="/contato" element={<ContatoPage />} />
            <Route path="/adm" element={<AdminLogin />} />
            <Route path="/adm/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AdminAuthProvider>
  );
}

export default App;